<div class="input-group fiori3-input-group cpq-system-id-wrapper" [class.flex-container]="hideLabel">
  @if (!editingMode && infoMessage) {
    <cpq-info class="cpq-info-icon float-right" [message]="infoMessage" (onInfoClick)="infoClicked()"></cpq-info>
  }
  @if (!editingMode && !hideLabel) {
    <label>{{ label| translate}}</label>
  }
  @if (!editingMode) {
    <div>
      <span [attr.id]="'systemId_' + value" class="text-muted"> {{value}}</span>
      @if (!readOnly) {
        <span [attr.id]="'editSystemId' + value" class="sap-icon" (click)="toggleEditSystemId()">&#xe038;</span>
      }
    </div>
  }
  @if (editingMode) {
    <cpq-input-error [disabled]="readOnly" (ngModelChange)='ngModelChange($event)' #name="ngModel" [label]="{key: hideLabel ? '' : label }" name="systemId" maxlength="300" [control]='name' [(ngModel)]="value" [hideLabel]="hideRequiredLabel" [cpqRequired]='true' [cpqNoWhiteSpace]='cpqNoWhiteSpace' ></cpq-input-error>
  }
  @if (editingMode && !iconAlert) {
    <div class="alert alert-info">
      <span class="sap-icon">&#xe202;</span>
      <div class="content">
        {{'AddEditTab.TabSystemIdWarning' | translate}}
      </div>
    </div>
  }
  @if (editingMode && iconAlert) {
    <div class="cpq-info-icon-container">
      <cpq-info [message]="{key: 'AddEditTab.TabSystemIdWarning'}"></cpq-info>
    </div>
  }
</div>